import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import slide1 from "../Images/history.jpg";
import slide2 from "../Images/opentosky.jpg";
import slide3 from "../Images/h8.jpeg";
import slide4 from "../Images/photo0jpg.jpg";
import slide5 from "../Images/silderhome4.jpg";
import slide6 from "../Images/night-view-from-food.jpg";
import slide8 from "../Images/mughal.jpeg";
import slide9 from "../Images/garden3.jpeg";
import slide10 from "../Images/grden2.jpeg";

const slidesData = [
  { image: slide1, caption: "Historic Walled City views" },
  { image: slide2, caption: "Open sky dining under the stars" },
  { image: slide3, caption: "Mughal architecture & ambience" },
  { image: slide4, caption: "Authentic Lahori cuisine" },
  { image: slide5, caption: "Memorable celebrations" },
  { image: slide6, caption: "Evening magic at Food Street" },
  { image: slide8, caption: "Royal dining experiences" },
  { image: slide9, caption: "Haveli Garden serenity" },
  { image: slide10, caption: "Heritage preserved with care" },
];

const HomeBanner = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const numOfSlides = slidesData.length;

  const goToSlide = (index) => {
    let next = index;
    if (next < 0) next = numOfSlides - 1;
    if (next >= numOfSlides) next = 0;
    setActiveIndex(next);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1 >= numOfSlides ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [numOfSlides]);

  return (
    <section className="slider hero-slider" aria-label="Hero slideshow">
      <div className="slider__slides">
        {slidesData.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === activeIndex ? "s--active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
            aria-hidden={index !== activeIndex}
          >
            <div className="slide__inner">
              <div className="slide__content">
                <div className="hero-content">
                  <span className="hero-eyebrow">Lahore&apos;s Iconic Heritage</span>
                  <h1 className="hero-title">Haveli Restaurant</h1>
                  <p className="hero-caption">{slide.caption}</p>
                  <p className="hero-subtitle">
                    Fine dining in the heart of the Walled City — where history, culture &amp; flavour unite.
                  </p>
                  <div className="hero-actions">
                    <Link to="/menu" className="hero-btn hero-btn--primary">
                      Explore Menu
                    </Link>
                    <Link to="/contact" className="hero-btn hero-btn--outline">
                      Book a Table
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="slider__control slider__control--left hero-nav-btn"
        aria-label="Previous slide"
        onClick={() => goToSlide(activeIndex - 1)}
      >
        ‹
      </button>
      <button
        type="button"
        className="slider__control slider__control--right hero-nav-btn"
        aria-label="Next slide"
        onClick={() => goToSlide(activeIndex + 1)}
      >
        ›
      </button>

      <div className="hero-dots" role="tablist" aria-label="Slide navigation">
        {slidesData.map((_, index) => (
          <button
            key={index}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            aria-label={`Go to slide ${index + 1}`}
            className={`hero-dot ${index === activeIndex ? "is-active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>

      <a href="#welcome" className="hero-scroll" aria-label="Scroll to content">
        <span className="hero-scroll__text">Discover</span>
        <span className="hero-scroll__line" />
      </a>
    </section>
  );
};

export default HomeBanner;
